module.exports = __webpack_public_path__ + "img/logo.b9e13803.jpg";